
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    MS: "MS",
    KMH: "KMH",
    KMS: "KMS",
    KT: "KT",
    MPH: "MPH",
    MPS: "MPS"
};
